import { ADMOB_CONFIG } from "./app";

interface AdMobPlatformConfig {
  appId: string;
  bannerId: string;
  platform: string;
}

interface AdMobConfig {
  ios: AdMobPlatformConfig;
  android: AdMobPlatformConfig;
  web: AdMobPlatformConfig;
}

const ADMOB: AdMobConfig = {
  ios: {
    appId: ADMOB_CONFIG.ios.appId,
    bannerId: ADMOB_CONFIG.ios.bannerId,
    platform: "iOS",
  },
  android: {
    appId: ADMOB_CONFIG.android.appId,
    bannerId: ADMOB_CONFIG.android.bannerId,
    platform: "Android",
  },
  web: {
    appId: ADMOB_CONFIG.web.appId,
    bannerId: ADMOB_CONFIG.web.bannerId,
    platform: "Web",
  },
};

export default ADMOB;
